const SITE = "https://www.recruitinglabitalia.it";

export function setCanonical(path) {
  let el = document.querySelector("link[rel='canonical']");
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", `${SITE}${path}`);
}

export function removeCanonical() {
  document.querySelectorAll("link[rel='canonical']").forEach((el) => el.remove());
}

export function setNoIndex(on, content = "noindex, nofollow") {
  let el = document.querySelector("meta[name='robots']");
  if (on) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", content);
  } else if (el) {
    el.remove();
  }
}
